import {RECEIVE_HOLIDAY_HOURS_DATA} from "../actions/facilitiesActions";

const initialState = {
};

export default function facilitiesReducer (state = initialState, action) {
  switch (action.type) {
    case RECEIVE_HOLIDAY_HOURS_DATA:

      let holidayHoursObject = {};

      holidayHoursObject[action.payload[0].airportCodeIATA] = action.payload[0];

      return {
        ...state,
        ...holidayHoursObject
      };
    default:
      return state
  }
};



// WEBPACK FOOTER //
// ./src/reducers/holidayHoursReducer.js